export const ELEMENTS_GAP = 1;
export const HEADING_SECTION_GAP = '70px';
export const HEADING_TO_SUBHEADING_GAP = '30px';
export const INPUTS_GAP = '10px';
export const CHECKBOX_GAP = '20px';
export const FORM_TO_CONTINUE_BTN_GaP = '50px';
